export const PRODUCT_AR = 'الكار كارنا';
export const PRODUCT_EN = 'CarCarNa';
export const PRODUCT_DISPLAY = 'CarCarNa الكار كارنا';

export const OPERATOR_AR = 'وكالة زيوت LOTOS دير الزور';
export const OPERATOR_EN = 'LOTOS Oils Agency – Deir ez-Zor';

export const OWNER_AR = 'السيد محمد محمد ناصر';
export const OWNER_EN = 'Mr. Muhammad Muhammad Nasir';

export const ADDRESS_AR = 'شارع الوسط، مقابل جامع الصفا، دير الزور، سوريا';
export const ADDRESS_EN = 'Al-Wasat Street, opposite Al-Safa Mosque, Deir ez-Zor, Syria';

export const OWNER_PHONE = '+963 947 128 542';
export const SUPPORT_EMAIL = 'info@carcarna.com';
export const WEBSITE = 'https://carcarna.com';

export const DEVELOPER_EN = 'Barmaja for Technical Solutions, United Arab Emirates';
export const DEVELOPER_AR = 'برمجة للحلول التقنية، الإمارات العربية المتحدة';

/**
 * Each document carries its own version. Bump one only for a material change;
 * the backend's `config/legal.php` and `@lubehub/api`'s SHIPPED_LEGAL_VERSIONS
 * must move with it, or registration and re-consent refuse the mismatch.
 */
export const PRIVACY_VERSION = '1.1';
export const PRIVACY_EFFECTIVE = '2026-09-25';
export const TERMS_VERSION = '1.0';
export const TERMS_EFFECTIVE = '2026-09-09';

export const PUBLIC_PATHS = {
  home: '/',
  privacy: '/privacy',
  terms: '/terms',
  support: '/support',
  accountDeletion: '/account-deletion',
  /**
   * A shared car.
   *
   * Deliberately **not** in the header navigation: it addresses one listing and
   * there is nothing to link to without an id. It exists so a link sent in
   * WhatsApp opens something a person can read.
   */
  car: '/cars/:id',
} as const;
